import React from "react";
import { Container} from "react-bootstrap";

import {MainHeader,MainFooter} from "./../components";

const DefaultLayout = (props) => <Container fluid>  
      {!props.noHeader && <MainHeader />}
      {props.children}
      {!props.noFooter && <MainFooter />}    
</Container>;


export default DefaultLayout;